export const AUTHORIZATION_SET_ELEMENTS = 'AUTHORIZATION_SET_ELEMENTS';

export const AUTHORIZATION_CLEAR_ELEMENTS = 'AUTHORIZATION_CLEAR_ELEMENTS';